import React from 'react'

function Tip() {
  return (
    <>
    <div>Required Documents</div>
    <ul className='w-[350px] list-disc px-5 mr-5'>
        <li>Signed letter (proceed to download a sample)</li>
        <li>National ID/Passport (for individuals)</li>
        <li>Certificate of Registration/Incorporation(for companies)</li> 
        <li>Taxt Certificate</li>
        
    </ul>
    </>
  )
}

export default Tip